import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { VariableBenefitConfigurationJurisdictionPaymentFormGroup } from '../../form-groups/variable-benefit-configuration-jurisdiction-payment-form-group';
import { ButtonTypeEnum } from '../../../../../../ui/buttons/button/button-type.enum';
import { VariableBenefitPaymentFrequencyEnum } from '../../../../../../models/enum/shared/variable-benefit-payment-frequency.enum';
import { FormErrorMessages } from '../../../../../../ui/form-components/form-error/form-error-messages';
import { StatusPill } from '../../../../../../models/shared/status-pill';

@Component({
  selector: 'app-vb-jurisdiction-lump-sum-payment-card',
  templateUrl: './vb-jurisdiction-lump-sum-payment-card.component.html',
  styleUrls: ['./vb-jurisdiction-lump-sum-payment-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class VbJurisdictionLumpSumPaymentCardComponent implements OnChanges {
  @Input({ required: true }) form!: VariableBenefitConfigurationJurisdictionPaymentFormGroup;
  @Input({ required: true }) paymentFrequency!: VariableBenefitPaymentFrequencyEnum;
  @Input() estimatedBalance: number = 0;
  @Input() estimatedAnnualTotal: number = 0;
  @Input() isLoadingAnnualTotal: boolean = false;
  @Input() isNew: boolean = false;
  @Input() disabled: boolean = false;
  @Input() minAnnualAmount: number = 0;
  @Input() maxAnnualAmount: number | null = null;
  @Input() maximumRaised = false;
  @Input() formSubmitted: boolean = false;
  @Input() refusal: string | null = null;

  @Output() lumpSumAdded = new EventEmitter<void>();

  public customErrorMessages!: Record<string, FormErrorMessages>;

  public ngOnChanges(): void {
    this.customErrorMessages = {
      estimatedMax: { exceedsMaximum: this.refusal ?? '' },
      lumpSumPaymentAmount: {
        max: $localize`The amount can not exceed the account's Est. Balance`,
        required: $localize`Enter a payment amount or remove the lump sum`
      }
    };
  }

  public newStatusPill = new StatusPill(0, $localize`New`, '#0D5D4B', '#E8F3F1');

  public createLumpSumPayment(): void {
    this.form.controls.hasLumpSumPayment.setValue(true);
    this.lumpSumAdded.emit();
  }

  public removeLumpSumPayment(): void {
    this.form.controls.hasLumpSumPayment.setValue(false);
  }

  protected readonly ButtonTypeEnum = ButtonTypeEnum;
  protected readonly VariableBenefitPaymentFrequencyEnum = VariableBenefitPaymentFrequencyEnum;
}
